// extracted by mini-css-extract-plugin
export default {"Cookie":"Cookie_Cookie__alPgh","Cookie__buttons":"Cookie_Cookie__buttons__IdpFV","Cookie__title":"Cookie_Cookie__title__KqlbC"};